/* unplugin-vue-components disabled */import script from "./InAppFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./InAppFrame.vue?vue&type=script&setup=true&lang=js"

import "./InAppFrame.vue?vue&type=style&index=0&id=51f32c70&lang=less"

const __exports__ = script;

export default __exports__